import { TextEditor, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const CollectionDescription = styled.div`
  width: 100%;
  word-break: break-word;

  ${TextEditor?.S?.TextEditorWrapper} {
    margin-top: calc(var(--size-components-input-height-md) / 2);
  }
`;

const TextEditorFooterText = styled(Typography)`
  margin-left: 8px;
  margin-right: 8px;
`;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
`;

export { CollectionDescription, TextEditorFooterText, TitleWrapper };
